export const commingSoonCitiesReducer = (state = {}, action) => {
  switch (action.type) {
    case "COMMING_SOON_CITIES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        cities: null,
      };
    case "COMMING_SOON_CITIES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        cities: action.payload,
      };
    case "COMMING_SOON_CITIES_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "COMMING_SOON_CITIES_ADD_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isAdded: false,
      };
    case "COMMING_SOON_CITIES_ADD_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isAdded: true,
      };
    case "COMMING_SOON_CITIES_ADD_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAdded: false,
      };

    case "COMMING_SOON_CITIES_UPDATE_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isUpdated: false,
      };
    case "COMMING_SOON_CITIES_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isUpdated: true,
      };
    case "COMMING_SOON_CITIES_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isUpdated: false,
      };

    case "COMMING_SOON_CITIES_REMOVE_REQUEST":
      return {
        ...state,
        loading: true,
        isDeleted: false,
      };
    case "COMMING_SOON_CITIES_REMOVE_SUCCESS":
      return {
        ...state,
        loading: false,
        isDeleted: true,
      };
    case "COMMING_SOON_CITIES_REMOVE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isDeleted: false,
      };

    case "SET_FETCHED_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
